/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
export const FETCH_LANGUAGE_DETAILS_REQUEST = "FETCH_LANGUAGE_DETAILS_REQUEST";
export const FETCH_LANGUAGE_DETAILS_SUCCESS = "FETCH_LANGUAGE_DETAILS_SUCCESS";
export const FETCH_LANGUAGE_DETAILS_FAILURE = "FETCH_LANGUAGE_DETAILS_FAILURE";
export const FETCH_CURRENT_LANGUAGE_DETAILS = "FETCH_CURRENT_LANGUAGE_DETAILS";
